<mat-card *ngIf="deals" class="backspace cursor title">
    <mat-card-title class="statsbg">Current Deals</mat-card-title>

    <mat-list>
        <mat-list-item *ngIf="!deals.itemsFilteredOrdered || deals.itemsFilteredOrdered.length === 0" class="empty-state">
            <mat-icon>sentiment_very_dissatisfied</mat-icon>
            <span>&nbsp;No current Deal</span>
        </mat-list-item>
        <mat-list-item *ngFor="let item of deals.itemsFilteredOrdered" class="deal-row">
            <div class="deal-container">
                <mat-icon matListIcon color="accent">{{item.icon}}</mat-icon>

                <div class="date-section">
                    {{item.date?.toDate() | date:'dd MMM yyyy'}}
                </div>

                <div class="name-section">
                    <div *ngIf="item.project?.contactsProjects">
                        <div *ngFor="let contactProject of item.project.contactsProjects">
                            {{ contactProject }}
                        </div>
                    </div>
                    <div *ngIf="item.mandate?.owners">
                        <div *ngFor="let owner of item.mandate.owners">
                            {{ owner }}
                        </div>
                    </div>
                </div>

                <div class="amount-section">
                  {{ item.cy | param:'cies' }} {{ calculTotal(item) | number }}
                </div>
            </div>
        </mat-list-item>
    </mat-list>

</mat-card>